import React from 'react';

import { Panel } from '../common/panel/Panel.component';
import { Button, Colors } from '../legacy/button/Button.component';
import { Input, InputType } from '../legacy/input/Input.component';
import styles from './VerifyTwoFactorAuth.module.css';

interface Props {
  verifyTwoFactorCode: (code: string) => void;
}

export const VerifyTwoFactorAuthComponent: React.FC<Props> = props => {
  const [twoFactorCode, setTwoFactorCode] = React.useState<string>('');

  const handleTwoFactorCodeChange = React.useCallback((value: string) => {
    setTwoFactorCode(value || '');
  }, []);

  const handleCodeVerify = () => {
    props.verifyTwoFactorCode(twoFactorCode);
  };

  return (
    <div className={styles.twoFactorAuth}>
      <Panel
        title="VERIFY TWO FACTOR CODE"
        className={styles.twoFactorAuthPanel}
      >
        <p className={styles.twoFactorAuthHeading}>
          Put in your two factor code from your authenticator app
        </p>
        <Input
          type={InputType.TEXT}
          label={'Copy the code from your Authenticator App'}
          value={twoFactorCode}
          onChange={handleTwoFactorCodeChange}
        />

        <div className={styles.buttonContainer}>
          <Button
            className={styles.secureAccountButton}
            color={Colors.COLOR_SCHEME_2}
            onClick={handleCodeVerify}
          >
            Verify Code
          </Button>
        </div>
      </Panel>
    </div>
  );
};
